/**
 * Sync store - tracks WebSocket connection state and lastSync timestamp.
 * Persisted to localStorage so reconnection after page reload sends the
 * correct delta window to the server.
 */

import { create } from 'zustand';

export type SyncStatus = 'disconnected' | 'connecting' | 'connected' | 'reconnecting';

interface SyncState {
  /** Current WebSocket connection status */
  status: SyncStatus;
  /** ISO timestamp of the last change received from the server */
  lastSync: string | null;
  /** Number of pending mutations waiting in the offline queue */
  pendingCount: number;

  setStatus: (status: SyncStatus) => void;
  setLastSync: (ts: string) => void;
  setPendingCount: (count: number) => void;
  /** Load lastSync from localStorage on init */
  loadLastSync: () => void;
}

export const useSyncStore = create<SyncState>((set) => ({
  status: 'disconnected',
  lastSync: null,
  pendingCount: 0,

  setStatus: (status) => set({ status }),

  setLastSync: (ts) => {
    set({ lastSync: ts });
    try {
      localStorage.setItem('anna-lastSync', ts);
    } catch {
      // localStorage unavailable (private browsing, etc.)
    }
  },

  setPendingCount: (count) => set({ pendingCount: count }),

  loadLastSync: () => {
    try {
      const stored = localStorage.getItem('anna-lastSync');
      if (stored) {
        set({ lastSync: stored });
      }
    } catch {
      // localStorage unavailable
    }
  },
}));
